import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { storage } from './storage';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_KEY,
    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: Number(process.env.REACT_APP_REVERB_PORT),
    wsPath: '',
    wssPort: Number(process.env.REACT_APP_REVERB_PORT),
    forceTLS: process.env.REACT_APP_FORCE_TLS === 'true',
    enabledTransports: ['ws'],
    cluster: 'eu',

    authEndpoint: `${process.env.REACT_APP_API_URL}/api/broadcasting/auth`,
    auth: {
        headers: {
            Authorization: `Bearer ${storage.get('token')}`,
            Accept: 'application/json'
        },
    },
});

export default echo;